/** The one "not set up" state for a gated page (gated.ts). */
import { Link } from '@tanstack/react-router';
import { Button, EmptyState } from '@velora/ui';
import { Plug, Wrench } from 'lucide-react';
import { splitHref } from '../patient/follow.js';
import type { ActiveGate } from './gated.js';

export function GatedState({
  gate,
  canSetUp,
  onOpenAnyway,
}: {
  gate: ActiveGate;
  canSetUp: boolean;
  onOpenAnyway: () => void;
}) {
  const target = splitHref(gate.setupHref);
  return (
    <div className="shell-page shell-page--center" data-testid="gated-state">
      <EmptyState
        icon={<Plug size={22} />}
        title={gate.title}
        description={
          <>
            {gate.missing} <strong>{gate.who}</strong>
          </>
        }
        actions={
          canSetUp ? (
            <div className="shell-gated__actions">
              <Button asChild variant="primary" leadingIcon={<Wrench size={14} aria-hidden />}>
                <Link
                  to={target.to as never}
                  {...(target.search ? { search: target.search as never } : {})}
                >
                  Set up
                </Link>
              </Button>
              <Button variant="ghost" onClick={onOpenAnyway}>
                Open anyway
              </Button>
            </div>
          ) : null
        }
      />
    </div>
  );
}
